// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#azure-warn[data-v-729e671d]{background-color:var(--warning);color:var(--warning-text);line-height:2em;width:100%}#azure-warn>p[data-v-729e671d]{text-align:center}", ""]);
// Exports
module.exports = exports;
